// NATIVE

// INSTALLED

// CUSTOM
import { setSgsstSelectRedux } from '../sgsst';
import { setCajaArlSelectRedux } from '../arl';
import { setCompanyRedux } from './companySlice';
import { setCountrySelectRedux } from '../country';
import { setDateValid } from '../../commons/utils';
import { setWorkPlaceSelectRedux } from '../work_place';
import { setBancosSelectRedux } from '../associated_bank';
import { setMunicipalysSelectRedux } from '../municipaly';
import { setDepartamentSelectRedux } from '../departament';
import { setMetodoPagoSelectRedux } from '../payment_method';
import { setTipoDocumentoSelectRedux } from '../type_document';
import { checkingPreload, unCheckingPreload } from '../loading';
import { setTypeAccountBankSelectRedux } from '../type_account_bank';
import { setPaymentFrecuencySelectRedux } from '../payment_frequency';
import { setActividadEconomicaSelectRedux } from '../economic_activity';
import {
  activeCompanyDetailService,
  desactiveCompanyDetailService,
  editCompanyService,
  getCompanyDataSelectsService,
  getCompanyDetailService,
  getCompanyServices,
  getDataFormInputsServiceCompany,
  saveCompanyService,
} from '../../services';

export const getCompanyStore = (): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    const result = await getCompanyServices();

    if (result.ok) {
      await dispatch(setCompanyRedux(result.data));
    }

    await dispatch(unCheckingPreload());

    return result;
  };
};

export const getCompanyDataSelects = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getCompanyDataSelectsService();

    if (result.ok) {
      await dispatch(setTipoDocumentoSelectRedux(result.data.tipoDocumentos));
      await dispatch(setActividadEconomicaSelectRedux(result.data.economicActivity));
      await dispatch(setCountrySelectRedux(result.data.pais));
      // await dispatch( setDepartamentSelectRedux(result.data.departamentos) );
      await dispatch(setWorkPlaceSelectRedux(result.data.sitioDeTrabajo));
      // await dispatch( setMunicipalysSelectRedux(result.data.municipios) );

      // PAGOS
      await dispatch(setPaymentFrecuencySelectRedux(result.data.frecuenciaDePago));
      await dispatch(setMetodoPagoSelectRedux(result.data.metodoPago));
      await dispatch(setBancosSelectRedux(result.data.bancos));
      await dispatch(setTypeAccountBankSelectRedux(result.data.tipoCuenta));

      // SEGURIDAD SOCIAL
      await dispatch(setSgsstSelectRedux(result.data.sgsst));
      await dispatch(setCajaArlSelectRedux(result.data.arls));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const saveCompany = (company: any, setPercentajeCCompany: any): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    const data_save = {
      typeDocument: company.type_document.value,
      number_document: company.number_document,
      tradename: company.tradename,
      business_name: company.business_name,
      legal_representative: company.legal_representative,
      email: company.email,
      manager_in_charge: company.manager_in_charge,
      branch_offices: Number(company.branch_offices),
      economicActivity: company.economic_activity.value,
      country: company.country.value,
      departament: company.departament.value,
      municipaly: company.municipaly.value,
      address_company: company.address_company,
      workPlace: company.workplace.value,
      landline: company.landline,
      cell_phone: company.cell_phone,
      paymentFrequency: company.payment_frequency.value,
      paymentMethod: company.payment_method.value,
      associatedBank: company.associated_bank.value,
      typeAccountBank: company.type_account_bank.value,
      account_number: company.account_number,
      sgsst: company.sgsst.value,
      arl: company.arl.value,
      constitution_date: setDateValid(company.constitution_date),
      ley_1429_2010: Number(company.ley_1429_2010),
      ley_590_2000: Number(company.ley_590_2000),
      ley_1607_2012: Number(company.ley_1607_2012),
      rut: company.rut_name_saved_file,
      chamber_of_commerce: company.chamber_of_commerce_name_saved_name,
      bank_certificate: company.bank_certificate_name_saved_name,
      logo_bn_rz_company: company.logo_bn_rz_company_name_saved_file,
      logo_bn_rz_post_company: company.logo_bn_rz_post_company_name_saved_file,
      logo_company: company.logo_company_name_saved_file,
      logo_post_company: company.logo_post_company_name_saved_file,
    };

    const result = await saveCompanyService(data_save, setPercentajeCCompany);

    await dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(storeCompany(result.data));
    }

    return result;
  };
};

export const storeEditCompany = (company: any, setPercentajeCCompany: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const data_save = {
      typeDocument: company.e_type_document.value,
      number_document: company.e_number_document,
      tradename: company.e_tradename,
      business_name: company.e_business_name,
      legal_representative: company.e_legal_representative,
      email: company.e_email,
      manager_in_charge: company.e_manager_in_charge,
      branch_offices: Number(company.e_branch_offices),
      economicActivity: company.e_economic_activity.value,
      country: company.e_country.value,
      departament: company.e_departament.value,
      municipaly: company.e_municipaly.value,
      address_company: company.e_address_company,
      workPlace: company.e_workplace.value,
      landline: company.e_landline,
      cell_phone: company.e_cell_phone,
      paymentFrequency: company.e_payment_frequency.value,
      paymentMethod: company.e_payment_method.value,
      associatedBank: company.e_associated_bank.value,
      typeAccountBank: company.e_type_account_bank.value,
      account_number: company.e_account_number,
      sgsst: company.e_sgsst.value,
      arl: company.e_arl.value,
      constitution_date: setDateValid(company.e_constitution_date),
      ley_1429_2010: Number(company.e_ley_1429_2010),
      ley_590_2000: Number(company.e_ley_590_2000),
      ley_1607_2012: Number(company.e_ley_1607_2012),
      rut: company.e_rut_name_saved_file ? company.e_rut_name_saved_file : company.actual_rut,
      chamber_of_commerce: company.e_chamber_of_commerce_name_saved_name
        ? company.e_chamber_of_commerce_name_saved_name
        : company.actual_chamber_of_commerce_name_saved_name,
      bank_certificate: company.e_bank_certificate_name_saved_name
        ? company.e_bank_certificate_name_saved_name
        : company.actual_bank_certificate,
      logo_company: company.e_logo_company_name_saved_file,
      logo_post_company: company.e_logo_post_company_name_saved_file,
      logo_bn_rz_company: company.e_logo_rz_company_name_saved_file,
      logo_bn_rz_post_company: company.e_logo_post_rz_company_name_saved_file,
      companyId: company.companyId,
    };

    const result = await editCompanyService(data_save);

    await dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(storeCompany(result.data));
    }

    return result;
  };
};

export const storeCompany = (companies: any) => {
  return async (dispatch: any) => {
    dispatch(setCompanyRedux(companies));
  };
};

export const storeDetailCompany = (companyId: string, percentage: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getCompanyDetailService(companyId, percentage);

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeDesactiveCompany = (companyId: string, percentage: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await desactiveCompanyDetailService(companyId, percentage);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(storeCompany(result.data.company));
    }

    return result;
  };
};

export const storeActiveCompany = (companyId: string, percentage: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await activeCompanyDetailService(companyId, percentage);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(storeCompany(result.data.company));
    }

    return result;
  };
};
